






































import { Vue, Component, Prop } from 'vue-property-decorator';

import ChevronRightSolid from '~/components/icons/ChevronRightSolid.vue';

@Component({
  components: { ChevronRightSolid },
})
export default class RelatedDestinationItem extends Vue {
  @Prop(Array) destinations: [];
  @Prop(Boolean) isLoading: false;

  /* Image fallback if card <img @error> is triggered */
  imageFallback (event: any) {
    event.target.src = "/img/placeholders/destination-placeholder.png";
  }

  /* Picture to display based on data. The media is resized with an util */
  picture (destination: Types.DestinationItem) {
    if (destination.header_pictures) return this.$thumbnailUrl(destination.header_pictures[0], 400);
    return destination.first_picture || '';
  }
}
